import React from 'react';

import Button from '@atlaskit/button';

import { StorageOfUniqueServices } from '@qality/common-service';

export const ShowIssueNavigatorButton = (): JSX.Element => {
  const goToJiraIssueNavigatorScreen = async (): Promise<void> => {
    const url = await StorageOfUniqueServices.get(
      'URLService'
    ).getTestCasesOverviewLink();
    window.open(url, '_blank');
  };

  return (
    <Button onClick={goToJiraIssueNavigatorScreen}>
      Show in Jira Issue Navigator
    </Button>
  );
};
